<template>
  <div>

    <create-customer-popup
      v-if="showAddModal"
      @close="showAddModal = false"
      @submitted="refreshData(); showAddModal = false;"
    />

    <b-card
      no-body
      class="mb-0"
    >

      <table-top
        show-add-button
        show-search
        @change:limit="limitChanged"
        @change:query="queryChanged"
        @click:add="showAddModal = true "
      />

      <rc-overlay :show="loading">
        <b-table
          ref="refUserListTable"
          class="position-relative"
          :items="customers"
          responsive
          :fields="tableColumns"
          primary-key="id"
          show-empty
          :empty-text="loading ? $t('shared.loading') : $t('shared.no-data') "
          :sort-by.sync="query.sortBy"
          :sort-desc.sync="query.isSortDirDesc"
        >

          <!-- Column: name -->
          <template #cell(name)="data">

            <b-link
              class="text-nowrap"
              :to="{ name: 'customer-edit', params: { id: data.item.id } }"
            >
              {{ data.item.name }}
            </b-link>

          </template>

          <!-- Column: Actions -->
          <template #cell(actions)="data">

            <b-link
              class="text-nowrap text-secondary"
              :to="{ name: 'customer-edit', params: { id: data.item.id } }"
            >
              <feather-icon
                icon="EditIcon"
                size="16"
              />
            </b-link>

          </template>

        </b-table>
      </rc-overlay>

      <table-bottom
        :query="query"
        :total="total"
      />
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BLink, BTable,
} from 'bootstrap-vue'
import TableTop from '@/layouts/components/table/TableTop.vue'
import CreateCustomerPopup from '@/views/customers/popups/CreateCustomerPopup.vue'
import TableBottom from '@/layouts/components/table/TableBottom.vue'
import RcOverlay from '@/layouts/components/rc/RcOverlay.vue'

export default {
  components: {
    TableBottom,
    CreateCustomerPopup,
    TableTop,
    RcOverlay,

    BCard,
    BTable,
    BLink,
  },
  data() {
    return {
      showAddModal: false,
      loading: false,

      total: 0,
      query: {
        sortBy: null,
        isSortDirDesc: false,
        query: null,
        limit: 10,
        page: 1,
      },

      tableColumns: [
        {
          label: this.$t('customer.label.name'),
          key: 'name',
          sortable: true,
        },
        {
          label: this.$t('customer.label.city'),
          key: 'city',
          sortable: true,
        },
        {
          label: this.$t('shared.actions'),
          key: 'actions',
          value: null,
          class: 'actions-column',
        },
      ],
    }
  },
  computed: {
    customers() {
      return this.$store.getters['customer/getCustomers']
    },
  },
  watch: {
    query: {
      handler() {
        this.refreshData()
      },
      deep: true,
    },
  },
  created() {
    this.refreshData()
  },
  methods: {
    refreshData() {
      this.loading = true
      const query = {
        q: this.query.query,
        sortField: this.query.sortBy,
        sortDir: this.query.isSortDirDesc ? 'desc' : 'asc',
        limit: this.query.limit,
        page: this.query.page,
      }

      Promise.all([this.$store.dispatch('customer/fetchCustomers', query)])
        .then(res => {
          if (this.query.page > 1 && res[0].data.items.length === 0) {
            this.query.page = 1
          }
          this.total = res[0].data.total
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    deleteCustomer(id) {
      return id
    },
    limitChanged(newLimit) {
      this.query.limit = newLimit
    },
    queryChanged(newQuery) {
      this.query.query = newQuery
    },
  },
}
</script>

<style lang="scss">

.actions-column {
  width: 1rem;
}
</style>
